import Platform from './platform';
import getUUID from './uuid';
import { generateUUID } from '../utils';

/**
 * 追加特殊字段，辅助查询分析日志
 * @param {String} type 日志级别
 * @param {Object} data 原始业务数据
 * @param {Object} config 配置项
 */
function handleData(type, data, config) {
  const time = Date.now();
  const configBak = config;

  config = config || configBak || {};

  if (['number', 'string'].indexOf(typeof data) > -1) {
    data = {
      data,
    };
  }

  if (['function'].indexOf(typeof data) > -1) {
    data = {
      data: data.toString(),
    };
  }

  data.localTime = time;

  const msg = JSON.stringify(data);
  let args = config.args || {};

  // 处理 args 字段值必须 string 问题
  Object.keys(args).forEach((key) => {
    args[key] = `${args[key]}`;
  });

  args = JSON.stringify(args);

  return {
    RID: `${generateUUID()}`,
    UID: `${config.uid || ''}`,
    UUID: `${getUUID()}`,
    MSG: msg,
    Args: args,
    BIN: `${config.platform || Platform.name}`,
    L: `${type || 'INFO'}`,
    ErrCode: `${config.errCode || '0'}`,
    T: `${time}`,
    EnvName: `${config.env || 'formal'}`,
    Biz: `${config.biz || 'YZ'}`,
    Platform: `${config.platform || Platform.name}`,
    Model: `${config.model || ''}`,
    LogType: `${config.logType || 'logic'}`,
    Dua: `DV=${config.version || '0.0.1'}&PL=${config.platform || Platform.name}`,
    Page: `${config.page || ''}`,
    Version: `${config.version || ''}`,
    Total: `${config.total || ''}`,
  };
}

export default handleData;
